"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = __importDefault(require("../../../../Button"));
const UnsupportedIcon_1 = __importDefault(require("../../Icons/UnsupportedIcon"));
const styled_1 = require("./styled");
const Unsupported = ({ handleClose }) => {
    return (react_1.default.createElement(styled_1.UnsupportedWrapper, null,
        react_1.default.createElement(UnsupportedIcon_1.default, null),
        react_1.default.createElement(styled_1.UnsupportedTitle, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-unavailable" })),
        react_1.default.createElement(styled_1.UnsupportedSubtitle, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-unavailable-alt" })),
        react_1.default.createElement(styled_1.UnsupportedBtnWrapper, null,
            react_1.default.createElement(Button_1.default, { design: "primary", onClick: handleClose },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-unavailable-button" })))));
};
exports.default = Unsupported;
//# sourceMappingURL=Unsupported.js.map